import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Box, Grid, Flex, Text, Card, Button } from '@radix-ui/themes';
import { reportService } from '../../services/guardian/reportService';

const GuardianReports = () => {
  const guardian = useSelector((state) => state.guardian);
  const students = guardian?.students || [];
  const [loading, setLoading] = useState(false);
  const [reports, setReports] = useState([]);

  useEffect(() => {
    const fetchReports = async () => {
      try {
        setLoading(true);
        if(students.length > 0) {
          const response = await reportService.getMultiStudentReports(students.map(student => student.id), 'guardian');
          setReports(response || []);
        } else {
          setReports([]);
        }
      } catch (error) {
        console.error('Error fetching reports:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchReports();
  }, [guardian.details.id]);

  return (
    <Box width="100%" maxWidth="1080px" p="4">
      <Grid columns="12" gap="4">
        <Box gridColumn="span 12">
          <Flex direction="column" gap="4">
            <Text size="5" weight="bold">Student Reports</Text>

            {loading ? (
              <Card>
                <Text>Loading reports...</Text>
              </Card>
            ) : reports.length === 0 ? (
              <Card>
                <Text>No reports available</Text>
              </Card>
            ) : (
              reports.map((report) => (
                <Card key={report.id}>
                  <Flex direction="column" gap="2">
                    <Text size="3" weight="bold">{report.title}</Text>
                    <Text size="2" color="gray">{report.description}</Text>
                    <Text size="2">Student: {report.student_name}</Text>
                    <Text size="2">Date: {new Date(report.created_at).toLocaleDateString()}</Text>
                    <Button variant="soft" size="2">View Details</Button>
                  </Flex>
                </Card>
              ))
            )}
          </Flex>
        </Box>
      </Grid>
    </Box>
  );
};

export default GuardianReports;
